function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M227.2 127.5h56.3v28.3h-56.3zM283.3 276l.2-.3v-31.8l-56.3-31.1V245zM283.5 39.6V7.5l-56.3 31.1v32.1zM205.5 50.1L117 99.3H0v84.9h117l88.5 49.2V50.1zm-99.1 105.6H28.5v-27.9h77.9v27.9zm70.6 29.2l-42-23.4v-39.6l42-23.4v86.4z"
})));